module.exports = __webpack_public_path__ + "static/media/gallery-6.cda076aa.jpg";